export default "__VITE_ASSET__9177d423__"